// removed by extract-text-webpack-plugin
module.exports = {"base":"_1zFSz","searchIcon":"_2BwQL","input":"_1MGvT","icon":"_2Kb1V","spinner":"s_FUu","clear":"_19NJF","clearIcon":"_24fDd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/List/components/Search/Search.scss
// module id = 2584
// module chunks = 0